<template>
  <div class="self-register-portal">
    <div class="portal-card">
      <div class="card-header">
        <h1>Self Registration</h1>
        <p>Welcome! Please provide your details to initiate your profile and onboarding.</p>
      </div>
      
      <div class="card-body">
        <div v-if="success" class="success-msg">
          <i class="bx bx-check-circle"></i>
          <h2>Registration Successful</h2>
          <p>Your details have been submitted to HR for verification. You will receive an email shortly with your next steps.</p>
          <router-link to="/" class="hr-btn hr-btn-primary hr-mt-4">Return to Login</router-link>
        </div>

        <form v-else @submit.prevent="submitRegistration" class="hr-form-grid">
          <div class="hr-filter-group span-full">
            <label class="hr-form-label">Full Name *</label>
            <input v-model="form.applicantName" type="text" class="hr-input" required placeholder="e.g. John Doe" />
          </div>
          <div class="hr-filter-group span-half">
            <label class="hr-form-label">Personal Email *</label>
            <input v-model="form.email" type="email" class="hr-input" required placeholder="john.doe@example.com" />
          </div>
          <div class="hr-filter-group span-half">
            <label class="hr-form-label">Phone Number *</label>
            <input v-model="form.phone" type="tel" class="hr-input" required placeholder="0700000000" />
          </div>
          <div class="hr-filter-group span-half">
            <label class="hr-form-label">National ID / Passport *</label>
            <input v-model="form.nationalId" type="text" class="hr-input" required />
          </div>
          <div class="hr-filter-group span-half">
            <label class="hr-form-label">Expected Role / Position</label>
            <input v-model="form.position" type="text" class="hr-input" placeholder="e.g. Software Engineer" />
          </div>
          <div class="hr-filter-group span-full">
            <label class="hr-form-label">Additional Notes</label>
            <textarea v-model="form.notes" class="hr-textarea" rows="3" placeholder="Any information HR should know..."></textarea>
          </div>
          
          <div class="form-actions span-full">
            <button type="submit" class="hr-btn hr-btn-primary" :disabled="submitting">
              {{ submitting ? 'Registering...' : 'Register Profile' }}
            </button>
            <router-link to="/careers" class="hr-btn hr-btn-outline hr-ml-2 hr-text-muted">View Vacancies Instead</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, execute2, toast } from "@/api";

export default {
  name: "SelfRegistration",
  data() {
    return {
      submitting: false,
      success: false,
      form: {
        applicantName: "",
        email: "",
        phone: "",
        nationalId: "",
        position: "",
        notes: ""
      }
    };
  },
  methods: {
    submitRegistration() {
      if (!this.form.applicantName || !this.form.email || !this.form.nationalId) {
        toast.warning("Please fill in all required fields.");
        return;
      }
      this.submitting = true;
      const data = new FormData();
      data.append("function", "submitSelfRegistration");
      data.append("applicantName", this.form.applicantName);
      data.append("email", this.form.email);
      data.append("phone", this.form.phone);
      data.append("nationalId", this.form.nationalId);
      data.append("positionTitle", this.form.position);
      data.append("coverLetter", this.form.notes);

      execute2(data, authUrl).then(res => {
        this.submitting = false;
        if (res.data.success) {
          this.success = true;
        } else {
          toast.error(res.data.message || "Registration failed.");
        }
      }).catch(() => {
        this.submitting = false;
        toast.error("An error occurred during registration. Please try again.");
      });
    }
  }
};
</script>

<style scoped>
.self-register-portal {
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4ff 0%, #eef2ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  font-family: 'Inter', 'DM Sans', sans-serif;
}

.portal-card {
  background: white;
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.card-header {
  background: #152c56;
  color: white;
  padding: 32px;
  text-align: center;
}

.card-header h1 {
  margin: 0 0 8px;
  font-size: 1.8rem;
}

.card-header p {
  color: #aab0bf;
  margin: 0;
  font-size: 0.95rem;
}

.card-body {
  padding: 32px;
}

.success-msg {
  text-align: center;
  padding: 20px 0;
}

.success-msg i {
  font-size: 4rem;
  color: #10b981;
  margin-bottom: 16px;
}

.success-msg h2 {
  color: #1e293b;
  margin-bottom: 8px;
}

.success-msg p {
  color: #64748b;
  line-height: 1.5;
}

.form-actions {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

/* Base UI components from main css used here */
.hr-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-size: 0.95rem;
  text-decoration: none;
  display: inline-block;
}

.hr-btn-primary { background: #4f46e5; color: white; transition: background 0.2s; }
.hr-btn-primary:hover { background: #4338ca; }
.hr-btn-primary:disabled { opacity: 0.7; cursor: not-allowed; }
.hr-btn-outline { background: transparent; border: 1px solid #cbd5e1; }
.hr-btn-outline:hover { background: #f8fafc; }
.hr-ml-2 { margin-left: 0.5rem; }
.hr-mt-4 { margin-top: 1rem; }
.hr-text-muted { color: #64748b; }

.hr-form-grid { display: grid; gap: 16px; }
.hr-filter-group { display: flex; flex-direction: column; }
.span-full { grid-column: 1 / -1; }
@media (min-width: 600px) {
  .hr-form-grid { grid-template-columns: 1fr 1fr; }
  .span-half { grid-column: span 1; }
}
@media (max-width: 599px) {
  .span-half { grid-column: 1 / -1; }
}

.hr-form-label { font-size: 0.85rem; font-weight: 500; margin-bottom: 6px; color: #475569; }
.hr-input, .hr-textarea {
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.95rem;
  transition: all 0.2s;
}
.hr-input:focus, .hr-textarea:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.2);
}
.hr-input::placeholder, .hr-textarea::placeholder { color: #94a3b8; }
</style>
